import { useCheckPermissions } from '@/shared';
import { SaveBodegas } from '../../shared/saveBodegasPage';
import { PermissionsEnum } from '@/auth/interfaces';

export interface CreateBodegasPageInterface {}

const CreateBodegasPage: React.FC<CreateBodegasPageInterface> = () => {
  useCheckPermissions(PermissionsEnum.api_add_bodega);

  return <SaveBodegas titlePage="Crear Bodegas" />;
};

export default CreateBodegasPage;
